import { CallSummary } from "../pages/customerservice/types.ts";
import { useApi } from "./useApi.ts";
import { saveAs } from "file-saver";

const API_BASE = process.env.REACT_APP_API_BASE as string;   // Vite 예시

export const useCallSummaryApi = () => {
    const { apiFetch } = useApi()

    const insertCallSummary = async (form: CallSummary) => {
        const res = await apiFetch(`${API_BASE}/customer-service/call-summary/insert`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        });
        if (!res.ok) throw new Error("server " + res.status);
        return res.blob();
      };

    const updateCallSummary = async (form: CallSummary) => {
        const res = await apiFetch(`${API_BASE}/customer-service/call-summary/${form.id}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        });
        if (!res.ok) throw new Error("server " + res.status);
        return res.blob();
      }

    const deleteCallSummary = async (id: String) => {
        const res = await apiFetch(`${API_BASE}/customer-service/call-summary/${id}`, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
        },
        });

        if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.error || "삭제 실패");
        }

        const data = await res.json();
        console.log("삭제 결과:", data);
        return data
    }

    // 데이터 로딩
    const getAllCallSummary = async () => {
        const res = await apiFetch(`${API_BASE}/customer-service/call-summary/get`);
        const json = await res.json();
        return json
    };


    return {
        insertCallSummary,
        updateCallSummary,
        deleteCallSummary,
        getAllCallSummary,
    }
}
